import { EpisodeRow } from "./EpisodeRow";
import styles from "./styles/EpisodeRow.module.css";

export function PopularEpisodes({ episodes }: { episodes: Episode[] | undefined }) {
    if (!episodes) {
        return null;
    }
    return (
        <ul className={styles.list}>
            {episodes.map((episode) =>
                episode.podcast ? (
                    <EpisodeRow
                        episode={episode}
                        key={`popular-episode-${episode.id}`}
                        podcast={episode.podcast}
                        showPodcast
                    />
                ) : null
            )}
        </ul>
    );
}
